import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: { padding: 40, fontFamily: 'Helvetica', fontSize: 12, lineHeight: 1.5 },  // Fallback to Helvetica
  title: { fontSize: 24, fontWeight: 'bold', marginBottom: 40, textAlign: 'center' },
  section: { marginTop: 20 },  // Layout only (no font styling here)
  sectionHeader: { fontSize: 14, fontWeight: 'bold' },  // Bold headers
  sectionText: { fontSize: 12, fontWeight: 'normal', marginTop: 10 },  // Non-bold paragraphs
  infoText: { fontSize: 14, textAlign: 'center', marginBottom: 5 },  // Header info (unchanged)
  list: { marginLeft: 20, marginTop: 5 },
  listItem: { marginBottom: 5, fontWeight: 'normal' },  // Ensure list items are non-bold
  signature: {
    marginTop: 30,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  signatureCell: { textAlign: 'center', width: '48%' },
  line: { width: '100%', height: 1, backgroundColor: '#000', marginTop: 5 },
  footer: { marginTop: 20 },
});

const ContractPDF = ({
  clientName = 'John Doe',
  packageTitle = 'Shine',
  monthlyPrice = '350',
  currencySymbol = '$',
  effectiveDate = new Date().toLocaleString('en-US', { 
    day: '2-digit', month: 'short', year: 'numeric',
    hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true 
  }).replace(',', ''),
  nextPaymentDate = (() => {
    const date = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
    return date.toLocaleString('en-US', { 
      day: '2-digit', month: 'short', year: 'numeric',
      hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true 
    }).replace(',', '');
  })(),
  componets = [],  // Default to empty array if not provided
}) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={{ textAlign: 'center' }}>
        <Text style={styles.title}>EcomElevate Service Agreement</Text>
        <Text style={styles.infoText}>Package: {packageTitle}</Text>
        <Text style={styles.infoText}>Date: {effectiveDate}</Text>
        <Text style={styles.infoText}>Price: {currencySymbol} {monthlyPrice} per month</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionHeader}>Parties</Text>
        <Text style={styles.sectionText}>
          This Service Agreement (the "Agreement") is entered into on {effectiveDate} (the "Effective Date") between:
        </Text>
        <View style={styles.list}>
          <Text style={styles.listItem}>
            • <Text style={{ fontWeight: 'bold' }}>EcomElevate (Pty) Ltd</Text>, a company providing ecommerce solutions, with its
            principal place of business: No physical address, fully online (herein referred to as
            "EcomElevate")
          </Text>
          <Text style={{ fontWeight: 'bold', textAlign: 'center', marginTop: 10, marginBottom: 10 }}>
            And
          </Text>
          <Text style={styles.listItem}>
            • <Text style={{ fontWeight: 'bold' }}>{clientName}</Text>, an individual or entity entering into this
            agreement for the provision of ecommerce services (herein referred to as the "Client").
          </Text>
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionHeader}>1. Services Provided</Text>
        <Text style={styles.sectionText}>
          EcomElevate agrees to provide the Client with all the {packageTitle} package benefits, which includes the following services:
        </Text>
        <View style={styles.list}>
          {componets.map((item, index) => (
            <Text key={index} style={styles.listItem}>• {item}</Text>
          ))}
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionHeader}>2. Payment Terms</Text>
        <Text style={styles.sectionText}>
          The Client agrees to pay EcomElevate the monthly fee of {currencySymbol}
          {monthlyPrice} for the {packageTitle} package. Payments are due on the same day of each subsequent month
          following the Effective Date (e.g., next payment due on {nextPaymentDate}). Payments shall be made via the
          payment method selected by the Client during the registration process, meaning you will be debited monthly on the card details you provided.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionHeader}>3. Termination for Non-Payment</Text>
        <Text style={styles.sectionText}>
          Failure to make a payment by the due date will result in a written notice from EcomElevate. If the payment
          remains unpaid for seven (7) days after the notice, EcomElevate reserves the right to terminate the Client's
          account and suspend all services. Upon termination, the Client will lose access to the ecommerce store and
          associated services.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionHeader}>4. Term and Termination</Text>
        <Text style={styles.sectionText}>
          This Agreement shall commence on the Effective Date and continue on a month-to-month basis until terminated by
          either party. The Client may terminate this Agreement by providing thirty (30) days' written notice to
          EcomElevate. EcomElevate may terminate this Agreement as outlined in Section 3 or for any material breach of
          this Agreement by the Client. Furthermore, EcomElevate reserves the right to immediately terminate this Agreement,
          without prior notice and without liability, in the event of any abuse of the services provided under this Agreement or
          if the Client engages in fraudulent, unlawful, or otherwise prohibited activities in connection with such services.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionHeader}>5. Acceptance</Text>
        <Text style={styles.sectionText}>
          By signing below (or electronically accepting during the signup process), the Client acknowledges that they
          have read, understood and agree to honour the terms of this Agreement.
        </Text>
      </View>

      <View style={styles.signature}>
        <View style={styles.signatureCell}>
          <Text style={{ marginTop: 10, marginBottom: 40 }}>EcomElevate Representatives:</Text>
          <Image src={require("../assets/Given_sign.png")} style={{ width: 100, height: 60, marginBottom: 10, alignSelf: 'center', border:'1' }} />
          <View style={styles.line} />
          <Text>Technical Director</Text>
          <Text>Date: {effectiveDate}</Text>

          <Text style={{ marginTop: 10, marginBottom: 10 }}></Text>
          <Image src={require("../assets/muzi_sign.png")} style={{ width: 100, height: 60, marginBottom: 10, alignSelf: 'center', border:'1' }} />
          <View style={styles.line} />
          <Text>Managing Director</Text>
          <Text>Date: {effectiveDate}</Text>
        </View>

        <View style={styles.signatureCell}>
          <Text style={{ marginTop: 10, marginBottom: 40 }}>Client</Text>
          <View style={styles.line} />
          <Text>{clientName}</Text>
          <Text>Date: {effectiveDate}</Text>
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionHeader}>6. Contact Information</Text>
        <View style={styles.list}>
          <Text style={styles.listItem}>• Email: support@ecomelevate.com</Text>
          <Text style={styles.listItem}>• Phone: +27 81 615 5344</Text>
          <Text style={styles.listItem}>• Address: EcomElevate is a 100% online platform - available to you anywhere, 24/7!</Text>
        </View>
      </View>
    </Page>
  </Document>
);

export default ContractPDF;